import api from './api';

const fetchIntegrationHealth = async () => {
  try {
    const { data } = await api.get('/integration-health');

    return { data: data.data };
  } catch (e) {
    return { errors: e.response?.data?.errors };
  }
};

export default { fetchIntegrationHealth };
